import React, { useState, useEffect, useRef } from 'react';
import ErpTemplate from '../../../components/ErpTemplate';
import { FaSave, FaThumbsUp } from 'react-icons/fa';
import api from '../../../services/api';
import { useHistory, useLocation } from 'react-router-dom';
import { buscarCep, data as formatData, dataHora, dataMysql, extract, parseCamposQuestionario, formatCrm, isTipoHcp, isNaoFarmaceutico, CARGO_OUTROS, CATEGORIA_NAO_FARMACEUTICO } from '../../../util/util';
import ReactSelect from '../../../components/ReactSelect';
import InputMask from 'react-input-mask';
import { toast } from 'react-toastify';
import moment from 'moment';
import Data from '../../../components/Data';
import { getText, getIdiomaCodigo } from '../../../util/translations';
import { getAuthPerfil, getAuthToken } from '../../../util/authSession';
import '../../../css/financeiro-parcela-pagar.css';
import { FinField, FinInput, FinTextarea, FinCheck } from '../../../components/FinField';
import { rotaDoStep, irParaProximoStep } from '../../../util/fluxoConvite';


export default function CadastroEventoParticipanteConvite({ match }) {
    const id = match.params.id;
    const token = getAuthToken();
    const perfil = getAuthPerfil();
    const contrato = new URLSearchParams(window.location.search).get('contrato');
    const [data, setData] = useState({ evento: { camposQuestionario: {} } });
    const [isLoading, setIsLoading] = useState(true);
    const [isError, setIsError] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    // Trava de concorrência: updated_at do participante no load, para o back barrar salvamento
    // sobre dados que já foram alterados por outra pessoa (ex.: operador) nesse meio tempo.
    const baseUpdatedAtRef = useRef(null);
    const history = useHistory();
    let { state } = useLocation();
    //var idEvento = state?.evento ?? null;
    const idioma = getIdiomaCodigo();
    // Convidado com idioma Inglês não preenche documentos brasileiros (CPF, RG, CRM, Estado CRM, Estado)
    const ocultarCamposBR = idioma === 'ingles';
    // HCP (1 - Hcp | 3 - Palestrante Hcp | 4 - Hcp Virtual) preenche CRM/Estado do CRM;
    // não-HCP preenche Dados/Estado do Conselho (ou marca N/A) no lugar
    const tipoHcp = isTipoHcp(data?.tipoparticipante);
    // ramo não farmacêutico: sem CRM, conselho nem especialidade.
    // Sem esse gate o convidado cairia no ramo não-HCP, que pede os dados do conselho. No evento
    // "Ambos" o ramo segue o tipo com que o convidado foi cadastrado.
    const naoFarmaceutico = isNaoFarmaceutico(data?.evento, data?.tipoparticipante ?? '');
    const isCampoAtivo = (...campos) => campos.some((campo) => (data?.evento?.camposQuestionario?.[campo] ?? "nao") === "sim");
    const preencherCep = (cep, dadosAtuais) => {
        buscarCep(cep).then((resposta) => {
            if (!resposta.erro) {
                setData({
                    ...dadosAtuais,
                    ...{
                        enderecobairro: resposta.bairro,
                        enderecocomplemento: resposta.complemento,
                        enderecologradouro: resposta.logradouro,
                        enderecopais: "30",
                        nomeEnderecopais: "Brasil",
                        enderecouf: resposta.uf,
                        enderecomunicipio: resposta.ibge,
                        nomeEnderecomunicipio: resposta.localidade
                    }
                });
            }
        });
    }

    const buscar = () => {
        setIsLoading(true);
        setIsError(false);
        api({
            method: "get",
            action: '/participante/' + id,
            token: token,
        }).then(response => {
            //extrai dados internos para o array principal
            var dadosRecebidos = extract({
                jsonLaravel: response.data.data,
                chaves: [
                    'enderecopais',
                    'aereomunicipioembarque',
                    'enderecomunicipio',
                    'cargoparticipante',
                    'banco',
                ]
            });



            const rawDataNascimento = dadosRecebidos.datanascimento;
            dadosRecebidos.datanascimento = (!rawDataNascimento || rawDataNascimento === '0000-00-00')
                ? ''
                : formatData(rawDataNascimento);
            //o back decide a etapa (proximoStep). Se esta tela ('dados') não é a etapa atual, redireciona.
            if (dadosRecebidos.proximoStep !== 'dados') {
                history.push(rotaDoStep(dadosRecebidos.proximoStep, { id, eventoId: dadosRecebidos.evento.id, contrato }));
                return;
            }

            dadosRecebidos.evento.camposQuestionario = parseCamposQuestionario(dadosRecebidos?.evento?.camposQuestionario);

            if (dadosRecebidos.pcd) {
                dadosRecebidos.pcdCheck = true;
            }

            if (dadosRecebidos.restricaoalimentar) {
                dadosRecebidos.restricaoalimentarCheck = true;
            }

            if (dadosRecebidos.acompanhantes) {
                dadosRecebidos.levaraAcompanhantes = "sim";
            }

            baseUpdatedAtRef.current = dadosRecebidos.updated_at ?? null; // versão carregada (trava de concorrência)
            setData(dadosRecebidos);
            setIsLoading(false);
        }).catch(err => {
            setIsLoading(false);
            setIsError(true);
            toast.error(`${getText('error')} ${getText('errorLoadingDefault')}`);
        });
    };//buscar

    const validar = async () => {
        if ((data?.evento.camposQuestionario.nome ?? "nao") === "sim") {
            var nome = document.querySelector("#nome");
            if ((data?.nome ?? '') === '') {
                toast.error(getText('requiredField') + ': ' + getText('nome_completo_documento_label'));
                setTimeout(() => {
                    nome.focus();
                }, 500);
                return false;
            }
        }

        if ((data?.evento.camposQuestionario.contato ?? "nao") === "sim") {
            var contato = document.querySelector("#contato");
            if ((data?.contato ?? '') === '') {
                toast.error(getText('requiredField') + ': ' + getText('nome_cracha_label'));
                setTimeout(() => {
                    contato.focus();
                }, 500);
                return false;
            }
        }

        if ((data?.evento.camposQuestionario.celular ?? "nao") === "sim") {
            var celular = document.querySelector("#celular");
            if ((data?.celular ?? '') === '') {
                toast.error(getText('requiredField') + ': ' + getText('celular_label'));
                setTimeout(() => {
                    celular.focus();
                }, 500);
                return false;
            }
        }

        if ((data?.evento.camposQuestionario.telefone ?? "nao") === "sim") {
            var telefone = document.querySelector("#telefone");
            if ((data?.telefone ?? '') === '') {
                toast.error(getText('requiredTelefone'));
                setTimeout(() => {
                    telefone.focus();
                }, 500);
                return false;
            }
        }

        if ((data?.evento.camposQuestionario.email ?? "nao") === "sim") {
            var email = document.querySelector("#email");
            if ((data?.email ?? '') === '') {
                toast.error(getText('requiredEmail'));
                setTimeout(() => {
                    email.focus();
                }, 500);
                return false;
            }
        }

        if (!ocultarCamposBR && (data?.evento.camposQuestionario.rg ?? "nao") === "sim") {
            var rg = document.querySelector("#rg");
            if ((data?.rg ?? '') === '') {
                toast.error(getText('requiredRg'));
                setTimeout(() => {
                    rg.focus();
                }, 500);
                return false;
            }
        }

        if (!ocultarCamposBR && (data?.evento.camposQuestionario.cpf ?? "nao") === "sim") {
            var cpf = document.querySelector("#cpf");
            if ((data?.cpf ?? '') === '') {
                toast.error(getText('requiredCpf'));
                setTimeout(() => {
                    cpf.focus();
                }, 500);
                return false;
            }
        }

        if (tipoHcp && !naoFarmaceutico && !ocultarCamposBR && (data?.evento.camposQuestionario.crm ?? "nao") === "sim") {
            var crm = document.querySelector("#crm");
            if ((data?.crm ?? '') === '') {
                toast.error(getText('requiredCrm'));
                setTimeout(() => {
                    crm.focus();
                }, 500);
                return false;
            }
        }


        if (tipoHcp && !naoFarmaceutico && !ocultarCamposBR && (data?.evento.camposQuestionario.crmuf ?? "nao") === "sim") {
            var crmuf = document.querySelector("#crmuf");
            if ((data?.crmuf ?? '') === '') {
                toast.error(getText('requiredCrmUf'));
                setTimeout(() => {
                    crmuf.focus();
                }, 500);
                return false;
            }
        }

        // não-HCP: Dados/Estado do Conselho no lugar do CRM (mesmos gates); N/A dispensa o preenchimento
        if (!tipoHcp && !naoFarmaceutico && !ocultarCamposBR && !(data?.conselhoNaoAplicavel ?? false) && (data?.evento.camposQuestionario.crm ?? "nao") === "sim") {
            var conselho = document.querySelector("#conselho");
            if ((data?.conselho ?? '') === '') {
                toast.error(getText('requiredConselho'));
                setTimeout(() => {
                    conselho.focus();
                }, 500);
                return false;
            }
        }

        if (!tipoHcp && !naoFarmaceutico && !ocultarCamposBR && !(data?.conselhoNaoAplicavel ?? false) && (data?.evento.camposQuestionario.crmuf ?? "nao") === "sim") {
            var conselhouf = document.querySelector("#conselhouf");
            if ((data?.conselhouf ?? '') === '') {
                toast.error(getText('requiredConselhoUf'));
                setTimeout(() => {
                    conselhouf.focus();
                }, 500);
                return false;
            }
        }

        if ((data?.evento.camposQuestionario.datanascimento ?? "nao") === "sim") {
            var datanascimento = document.querySelector("#datanascimento");
            if ((data?.datanascimento ?? '') === '') {
                toast.error(getText('requiredDataNascimento'));
                setTimeout(() => {
                    datanascimento.focus();
                }, 500);
                return false;
            }
        }

        if (naoFarmaceutico && (data?.evento.camposQuestionario.cargoparticipante ?? "nao") === "sim") {
            if ((data?.cargoparticipante ?? '') === '') {
                toast.error(getText('requiredCargo'));
                return false;
            }
            // "Outros" sem especificação não identifica ninguém — mesma regra da importação
            if (String(data?.cargoparticipante) === CARGO_OUTROS && (data?.cargoespecificacao ?? '').trim() === '') {
                var cargoespecificacao = document.querySelector("#cargoespecificacao");
                toast.error(getText('requiredCargoEspecificacao'));
                setTimeout(() => {
                    cargoespecificacao?.focus();
                }, 500);
                return false;
            }
        }

        if (!naoFarmaceutico && (data?.evento.camposQuestionario.especialidade ?? "nao") === "sim") {
            var especialidade = document.querySelector("#especialidade");
            if ((data?.especialidade ?? '') === '') {
                toast.error(getText('requiredEspecialidade'));
                setTimeout(() => {
                    especialidade.focus();
                }, 500);
                return false;
            }
        }

        if ((data?.evento.camposQuestionario.instituicao ?? "nao") === "sim") {
            var instituicao = document.querySelector("#instituicao");
            if ((data?.instituicao ?? '') === '') {
                toast.error(getText('requiredInstituicao'));
                setTimeout(() => {
                    instituicao.focus();
                }, 500);
                return false;
            }
        }


        if ((data?.evento.camposQuestionario.idconvidado ?? "nao") === "sim") {
            var idconvidado = document.querySelector("#idconvidado");
            if ((data?.idconvidado ?? '') === '') {
                toast.error(getText('requiredIdConvidado'));
                setTimeout(() => {
                    idconvidado?.focus();
                }, 500);
                return false;
            }
        }

        if ((data?.evento.camposQuestionario.socio ?? "nao") === "sim") {
            var socio = document.querySelector("#socio");
            if ((data?.socio ?? '') === '') {
                toast.error(getText('requiredSocio'));
                setTimeout(() => {
                    socio?.focus();
                }, 500);
                return false;
            }
        }

        if ((data?.evento.camposQuestionario.passaporte ?? "nao") === "sim") {
            var passaporte = document.querySelector("#passaporte");
            if ((data?.passaporte ?? '') === '') {
                toast.error(getText('requiredPassaporte'));
                setTimeout(() => {
                    passaporte?.focus();
                }, 500);
                return false;
            }
        }

        if ((data?.evento.camposQuestionario.passaportevencimento ?? "nao") === "sim") {
            var passaportevencimento = document.querySelector("#passaportevencimento");
            if ((data?.passaportevencimento ?? '') === '') {
                toast.error(getText('requiredPassaporteVencimento'));
                setTimeout(() => {
                    passaportevencimento?.focus();
                }, 500);
                return false;
            }
        }

        if ((data?.evento.camposQuestionario.produto ?? "nao") === "sim") {
            var produto = document.querySelector("#produto");
            if ((data?.produto ?? '') === '') {
                toast.error(getText('requiredProduto'));
                setTimeout(() => {
                    produto?.focus();
                }, 500);
                return false;
            }
        }

        if ((data?.evento.camposQuestionario.ordeminterna ?? "nao") === "sim") {
            var ordeminterna = document.querySelector("#ordeminterna");
            if ((data?.ordeminterna ?? '') === '') {
                toast.error(getText('requiredOrdemInterna'));
                setTimeout(() => {
                    ordeminterna?.focus();
                }, 500);
                return false;
            }
        }

        if ((data?.evento.camposQuestionario.gerentecomercial ?? "nao") === "sim") {
            var gerentecomercial = document.querySelector("#gerentecomercial");
            if ((data?.gerentecomercial ?? '') === '') {
                toast.error(getText('requiredGerenteComercial'));
                setTimeout(() => {
                    gerentecomercial?.focus();
                }, 500);
                return false;
            }
        }

        if ((data?.evento.camposQuestionario.gerentedistrital ?? "nao") === "sim") {
            var gerentedistrital = document.querySelector("#gerentedistrital");
            if ((data?.gerentedistrital ?? '') === '') {
                toast.error(getText('requiredGerenteDistrital'));
                setTimeout(() => {
                    gerentedistrital?.focus();
                }, 500);
                return false;
            }
        }

        if ((data?.evento.camposQuestionario.gerentedistritalemail ?? "nao") === "sim") {
            var gerentedistritalemail = document.querySelector("#gerentedistritalemail");
            if ((data?.gerentedistritalemail ?? '') === '') {
                toast.error(getText('requiredGerenteDistritalEmail'));
                setTimeout(() => {
                    gerentedistritalemail?.focus();
                }, 500);
                return false;
            }
        }

        if ((data?.evento.camposQuestionario.representante ?? "nao") === "sim") {
            var representante = document.querySelector("#representante");
            if ((data?.representante ?? '') === '') {
                toast.error(getText('requiredRepresentante'));
                setTimeout(() => {
                    representante?.focus();
                }, 500);
                return false;
            }
        }

        if ((data?.evento.camposQuestionario.representanteemail ?? "nao") === "sim") {
            var representanteemail = document.querySelector("#representanteemail");
            if ((data?.representanteemail ?? '') === '') {
                toast.error(getText('requiredRepresentanteEmail'));
                setTimeout(() => {
                    representanteemail?.focus();
                }, 500);
                return false;
            }
        }

        if ((data?.evento.camposQuestionario.representantetelefone ?? "nao") === "sim") {
            var representantetelefone = document.querySelector("#representantetelefone");
            if ((data?.representantetelefone ?? '') === '') {
                toast.error(getText('requiredRepresentanteTelefone'));
                setTimeout(() => {
                    representantetelefone?.focus();
                }, 500);
                return false;
            }
        }

        if ((data?.evento.camposQuestionario.enderecocep ?? "nao") === "sim") {
            var enderecocep = document.querySelector("#enderecocep");
            if ((data?.enderecocep ?? '') === '') {
                toast.error(getText('requiredCep'));
                setTimeout(() => {
                    enderecocep.focus();
                }, 500);
                return false;
            }
        }

        if ((data?.evento.camposQuestionario.enderecologradouro ?? "nao") === "sim") {
            var enderecologradouro = document.querySelector("#enderecologradouro");
            if ((data?.enderecologradouro ?? '') === '') {
                toast.error(getText('requiredRua'));
                setTimeout(() => {
                    enderecologradouro.focus();
                }, 500);
                return false;
            }
        }

        if ((data?.evento.camposQuestionario.endereconumero ?? "nao") === "sim") {
            var endereconumero = document.querySelector("#endereconumero");
            if ((data?.endereconumero ?? '') === '') {
                toast.error(getText('requiredNumero'));
                setTimeout(() => {
                    endereconumero.focus();
                }, 500);
                return false;
            }
        }

        if ((data?.evento.camposQuestionario.enderecobairro ?? "nao") === "sim") {
            var enderecobairro = document.querySelector("#enderecobairro");
            if ((data?.enderecobairro ?? '') === '') {
                toast.error(getText('requiredBairro'));
                setTimeout(() => {
                    enderecobairro.focus();
                }, 500);
                return false;
            }
        }

        if (!ocultarCamposBR && isCampoAtivo('enderecomunicipio', 'enderecomunicipionome')) {
            var enderecomunicipio = document.querySelector("#enderecomunicipio");
            if ((data?.enderecomunicipio ?? '') === '') {
                toast.error(getText('requiredMunicipio'));
                setTimeout(() => {
                    enderecomunicipio.focus();
                }, 500);
                return false;
            }
        }

        if (!ocultarCamposBR && isCampoAtivo('enderecouf', 'enderecomunicipiouf')) {
            var enderecouf = document.querySelector("#enderecouf");
            if ((data?.enderecouf ?? '') === '') {
                toast.error(getText('requiredEstado'));
                setTimeout(() => {
                    enderecouf.focus();
                }, 500);
                return false;
            }
        }

        if ((data?.evento.camposQuestionario.inscricao ?? "nao") === "sim") {
            var inscricao = document.querySelector("#inscricao");
            if ((data?.inscricao ?? '') === '') {
                toast.error(getText('requiredInscricao'));
                setTimeout(() => {
                    inscricao?.focus();
                }, 500);
                return false;
            }
        }

        if ((data?.evento.camposQuestionario.inscricaonumero ?? "nao") === "sim") {
            var inscricaonumero = document.querySelector("#inscricaonumero");
            if ((data?.inscricaonumero ?? '') === '') {
                toast.error(getText('requiredInscricaoNumero'));
                setTimeout(() => {
                    inscricaonumero?.focus();
                }, 500);
                return false;
            }
        }

        if (!ocultarCamposBR && (data?.aereo ?? "nao") === "sim") {
            if ((data?.evento.camposQuestionario.aereomunicipioembarque ?? "nao") === "sim") {
                var aereomunicipioembarque = document.querySelector("#aereomunicipioembarque");
                if ((data?.aereomunicipioembarque ?? '') === '') {
                    toast.error(getText('requiredCidadeEmbarque'));
                    setTimeout(() => {
                        aereomunicipioembarque.focus();
                    }, 500);
                    return false;
                }
            }
        }

        if ((data?.evento.camposQuestionario.necessidadeespecial ?? "nao") === "sim") {
            if ((data?.restricaoalimentarCheck ?? false) === true) {
                var restricaoalimentar = document.querySelector("#restricaoalimentar");
                if ((data?.restricaoalimentar ?? '') === '') {
                    toast.error(getText('requiredRestricaoAlimentar'));
                    setTimeout(() => {
                        restricaoalimentar.focus();
                    }, 500);
                    return false;
                }
            }
            if ((data?.pcdCheck ?? false) === true) {
                var pcd = document.querySelector("#pcd");
                if ((data?.pcd ?? '') === '') {
                    toast.error(getText('requiredPcd'));
                    setTimeout(() => {
                        pcd.focus();
                    }, 500);
                    return false;
                }
            }
        }

        if ((data?.evento.camposQuestionario.observacao ?? "nao") === "sim") {
            var observacao = document.querySelector("#observacao");
            if ((data?.observacao ?? '') === '') {
                toast.error(getText('requiredObservacao'));
                setTimeout(() => {
                    observacao?.focus();
                }, 500);
                return false;
            }
        }

        // Colunas nomeáveis: `data.colunas` vem normalizado do back, uma entrada por coluna do
        // evento. `questionar` é o que o camposQuestionario dizia, e `ativo` é o cadeado — coluna
        // travada não é perguntada ao convidado, logo também não é exigida.
        for (const coluna of (data?.colunas ?? [])) {
            if (!coluna.questionar || !coluna.ativo) {
                continue;
            }
            if ((coluna.valor ?? '') === '') {
                toast.error(getText('requiredColumn') + `: ${coluna.nome}`);
                const campo = document.querySelector(`#coluna${coluna.ordem}`);
                setTimeout(() => {
                    campo?.focus();
                }, 500);
                return false;
            }
        }

        if ((data?.evento?.cliente?.modelo ?? "") === "access" &&
            (data?.levaraAcompanhantes ?? "nao") === "sim" &&
            (!data?.acompanhantes || data.acompanhantes.trim() === '')) {
            toast.error(getText('requiredAcompanhantes'));
            setTimeout(() => {
                document.getElementById('acompanhantes')?.focus();
            }, 500);
            return false;
        }

        return true;
    };

    const salvar = async () => {
        if (!(await validar())) {
            return false;
        }

        setIsSubmitting(true);

        const idEvento = data?.evento.id;

        // auto-pick every campo that is active and exists as a field in data
        const fromCampos = Object.entries(data?.evento?.camposQuestionario ?? {})
            .filter(([campo, ativo]) => ativo === 'sim' && campo in data)
            .reduce((acc, [campo]) => ({ ...acc, [campo]: data[campo] }), {});

        const dadosSalvar = {
            ...fromCampos,
            ...(fromCampos.datanascimento && { datanascimento: dataMysql(fromCampos.datanascimento) }),
            // alias campos: camposQuestionario key differs from the actual data field name
            ...(isCampoAtivo('enderecomunicipio', 'enderecomunicipionome') && { enderecomunicipio: data.enderecomunicipio }),
            ...(isCampoAtivo('enderecouf', 'enderecomunicipiouf') && { enderecouf: data.enderecouf }),
            enderecopais: data.enderecopais,
            restricaoalimentar: data.restricaoalimentar,
            pcd: data.pcd,
            // dados do conselho (não-HCP): não estão no camposQuestionario, vão explícitos
            ...(!tipoHcp && !naoFarmaceutico && !ocultarCamposBR && {
                conselho: data.conselho ?? null,
                conselhouf: data.conselhouf ?? null,
                conselhoNaoAplicavel: !!data.conselhoNaoAplicavel,
            }),
            // a especificação do cargo não está no camposQuestionario (o cargo está), vai explícita
            ...(naoFarmaceutico && (data?.evento?.camposQuestionario?.cargoparticipante ?? "nao") === "sim" && {
                cargoespecificacao: String(data.cargoparticipante ?? '') === CARGO_OUTROS ? (data.cargoespecificacao ?? null) : null,
            }),
            acompanhantes: data.acompanhantes,
            // Colunas nomeáveis: o `dadosSalvar` é allowlist, não spread de `data`, então elas
            // precisam entrar explicitamente — antes iam de carona no fromCampos pelas chaves
            // colunaN do camposQuestionario. Manda só o que foi perguntado e não está travado: o
            // convidado não escreve em coluna que a tela não mostrou.
            colunas: (data?.colunas ?? [])
                .filter(coluna => coluna.questionar && coluna.ativo)
                .map(coluna => ({ id: coluna.id, ordem: coluna.ordem, valor: coluna.valor ?? '' })),
            dataconfirmacaodados: moment().format('YYYY-MM-DD'),
            dadosConfirmados: true,
        };

        // trava de concorrência: manda a versão carregada para o back barrar escrita desatualizada
        dadosSalvar.baseUpdatedAt = baseUpdatedAtRef.current;

        api({
            method: 'put',
            action: '/participante/' + id,
            token: token,
            data: dadosSalvar,
        })
            .then(function (response) {
                toast.success(getText('dadosSalvosSucesso'));
                //o back resolve a próxima etapa com o estado fresco pós-save (overlay de load durante o GET).
                irParaProximoStep(history, { id, token, eventoId: idEvento, contrato, setLoading: setIsLoading });
            })
            .catch(function (error) {
                const dataErro = error.response?.data;
                // trava de concorrência: registro alterado por outra pessoa depois do load
                if (error.response?.status === 409 && dataErro?.error === 'STALE_WRITE') {
                    toast.error(getText('dadosDesatualizados'), { autoClose: 8000 });
                    return;
                }
                // 422 com campos faltando: traduz os nomes dos campos via getText (em vez da msg crua do backend)
                if (error.response?.status === 422 && Array.isArray(dataErro?.camposFaltando) && dataErro.camposFaltando.length) {
                    const labels = dataErro.camposFaltando.map(c => getText(c + '_label') ?? getText(c) ?? c).join(', ');
                    toast.error(getText('requiredFieldsNotFilled') + ': ' + labels, { autoClose: 8000 });
                    return;
                }
                if (error.response?.status === 422 && dataErro?.message) {
                    toast.error(dataErro.message, { autoClose: 8000 });
                    return;
                }
                toast.error(`${getText('error')} ${getText('errorSavingDefault')}`);
            })
            .finally(() => {
                setIsSubmitting(false);
            });
    };

    useEffect(() => { //onload
        buscar();
    },
        // eslint-disable-next-line
        []);

    return (
        <ErpTemplate sidebar={['listarsvp', 'cliente'].includes(perfil) ? false : true} processando={isLoading} idioma={idioma ?? "both"}>
            <div className="main-content container-fluid fin-pp">
                {!isLoading && !isError && data?.evento?.id && <>
                    <div className="fin-pp__head">
                        <div>
                            <h2 className="fin-pp__title">{getText('confirmacao_dados_titulo')}</h2>
                        </div>
                        <div className="fin-pp__actions">
                            <button type="button" className="fin-pp__btn fin-pp__btn--primary fin-pp__btn--pill" onClick={salvar} disabled={isSubmitting}>
                                {isSubmitting ? getText('salvando') : getText('confirmar_dados_botao')}
                            </button>
                        </div>
                    </div>
                    <div className="fin-pp__card" style={{ padding: '16px' }}>
                        <form onSubmit={(e) => { salvar(); e.preventDefault(); }}>
                            <div className="fin-pp__filters">
                                {(data?.evento?.camposQuestionario?.nome ?? "nao") === "sim" ? (
                                    <>
                                        <FinField label={getText('nome_completo_documento_label')} required>
                                            <FinInput
                                                id="nome"
                                                value={data?.nome ?? ''}
                                                onChange={e => setData({ ...data, ...{ "nome": e.target.value } })}
                                                style={{ paddingLeft: 14 }}
                                            />
                                        </FinField>
                                        {(data?.evento?.cliente?.modelo ?? "") !== "access" && (
                                            <div style={{ gridColumn: '1 / -1', marginTop: '-8px', marginBottom: '4px' }}>
                                                <strong>{getText('nome_atencao_aereo')}</strong>
                                            </div>
                                        )}
                                    </>
                                ) : null}

                                {(data?.evento?.camposQuestionario?.contato ?? "nao") === "sim" ? (
                                    <FinField label={getText('nome_cracha_label')} required>
                                        <FinInput
                                            id="contato"
                                            value={data?.contato ?? ''}
                                            onChange={e => setData({ ...data, ...{ "contato": e.target.value } })}
                                            style={{ paddingLeft: 14 }}
                                        />
                                    </FinField>
                                ) : null}

                                {(data?.evento?.camposQuestionario?.celular ?? "nao") === "sim" ? (
                                    <FinField label={getText('celular_label')} required>
                                        <InputMask
                                            mask="(99) 99999-9999"
                                            className="fin-pp__input"
                                            id="celular"
                                            value={data?.celular ?? ''}
                                            onChange={e => setData({ ...data, ...{ "celular": e.target.value } })}
                                            style={{ paddingLeft: 14 }}
                                        />
                                    </FinField>
                                ) : null}

                                {(data?.evento?.camposQuestionario?.telefone ?? "nao") === "sim" ? (
                                    <FinField label={getText('telefone_label')} required>
                                        <InputMask
                                            mask="(99) 99999-9999"
                                            className="fin-pp__input"
                                            id="telefone"
                                            value={data?.telefone ?? ''}
                                            onChange={e => setData({ ...data, ...{ "telefone": e.target.value } })}
                                            style={{ paddingLeft: 14 }}
                                        />
                                    </FinField>
                                ) : null}

                                {(data?.evento?.camposQuestionario?.email ?? "nao") === "sim" ? (
                                    <FinField label={getText('email_label')} required>
                                        <FinInput
                                            id="email"
                                            value={data?.email ?? ''}
                                            onChange={e => setData({ ...data, ...{ "email": e.target.value } })}
                                            style={{ paddingLeft: 14 }}
                                        />
                                    </FinField>
                                ) : null}

                                {!ocultarCamposBR && (data?.evento?.camposQuestionario?.rg ?? "nao") === "sim" ? (
                                    <FinField label={getText('rg_label')} required>
                                        <FinInput
                                            id="rg"
                                            value={data?.rg ?? ''}
                                            onChange={e => setData({ ...data, ...{ "rg": e.target.value } })}
                                            style={{ paddingLeft: 14 }}
                                        />
                                    </FinField>
                                ) : null}

                                {!ocultarCamposBR && (data?.evento?.camposQuestionario?.cpf ?? "nao") === "sim" ? (
                                    <FinField label={getText('cpf_label')} required>
                                        <InputMask
                                            mask="999.999.999-99"
                                            className="fin-pp__input"
                                            id="cpf"
                                            value={data?.cpf ?? ''}
                                            onChange={e => setData({ ...data, ...{ "cpf": e.target.value } })}
                                            style={{ paddingLeft: 14 }}
                                        />
                                    </FinField>
                                ) : null}

                                {tipoHcp && !naoFarmaceutico && !ocultarCamposBR && (data?.evento?.camposQuestionario?.crm ?? "nao") === "sim" ? (
                                    <FinField label={getText('crm_label')} required>
                                        <FinInput
                                            id="crm"
                                            value={data?.crm ?? ''}
                                            onChange={e => {
                                                // UF: 2 letras digitadas (auto-seleciona o estado) ou o select; número
                                                // preenche da direita (mín. 6 / máx. 7), preservando zeros digitados.
                                                const r = formatCrm(e.target.value, data?.crm, data?.crmuf);
                                                setData({ ...data, ...{ "crm": r.crm, "crmuf": r.crmuf, "nomeUf": r.crmuf } });
                                            }}
                                            style={{ paddingLeft: 14 }}
                                        />
                                    </FinField>
                                ) : null}

                                {tipoHcp && !naoFarmaceutico && !ocultarCamposBR && (data?.evento?.camposQuestionario?.crmuf ?? "nao") === "sim" ? (
                                    <FinField label={getText('estado_crm_label')} required>
                                        <ReactSelect
                                            id={"crmuf"}
                                            value={{ value: data?.crmuf ?? '', label: data?.crmuf ?? '' }}
                                            onChange={e => {
                                                // ao trocar a UF, reaplica o prefixo no CRM mantendo o número já digitado
                                                const r = formatCrm((e.value || '') + (data?.crm ?? '').replace(/\D/g, ''), data?.crm, e.value);
                                                setData({ ...data, ...{ "crmuf": e.value, "nomeUf": e.label, "crm": r.crm } });
                                            }}
                                            options={[
                                                { value: "AC", label: "AC" },
                                                { value: "AL", label: "AL" },
                                                { value: "AP", label: "AP" },
                                                { value: "AM", label: "AM" },
                                                { value: "BA", label: "BA" },
                                                { value: "CE", label: "CE" },
                                                { value: "DF", label: "DF" },
                                                { value: "ES", label: "ES" },
                                                { value: "GO", label: "GO" },
                                                { value: "MA", label: "MA" },
                                                { value: "MT", label: "MT" },
                                                { value: "MS", label: "MS" },
                                                { value: "MG", label: "MG" },
                                                { value: "PA", label: "PA" },
                                                { value: "PB", label: "PB" },
                                                { value: "PR", label: "PR" },
                                                { value: "PE", label: "PE" },
                                                { value: "PI", label: "PI" },
                                                { value: "RJ", label: "RJ" },
                                                { value: "RN", label: "RN" },
                                                { value: "RS", label: "RS" },
                                                { value: "RO", label: "RO" },
                                                { value: "RR", label: "RR" },
                                                { value: "SC", label: "SC" },
                                                { value: "SP", label: "SP" },
                                                { value: "SE", label: "SE" },
                                                { value: "TO", label: "TO" },
                                            ]}
                                        />
                                    </FinField>
                                ) : null}

                                {!tipoHcp && !naoFarmaceutico && !ocultarCamposBR && (data?.evento?.camposQuestionario?.crm ?? "nao") === "sim" ? (
                                    <div className="fin-pp__field">
                                        {/* N/A junto do label externo, no mesmo field: nunca se separa do campo no grid dinâmico */}
                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12 }}>
                                            <label className="fin-pp__label" htmlFor="conselho">
                                                {getText('conselho_label')}{!(data?.conselhoNaoAplicavel ?? false) ? <span style={{ color: 'var(--fin-dg)' }}> *</span> : null}
                                            </label>
                                            <FinCheck
                                                id="conselhoNaoAplicavel"
                                                label={getText('conselho_na_label')}
                                                checked={data?.conselhoNaoAplicavel ?? false}
                                                onChange={e => {
                                                    const isChecked = e.target.checked;
                                                    setData({
                                                        ...data,
                                                        conselhoNaoAplicavel: isChecked,
                                                        ...(isChecked ? { conselho: '', conselhouf: '' } : {})
                                                    });
                                                }}
                                            />
                                        </div>
                                        <FinInput
                                            id="conselho"
                                            placeholder={getText('conselho')}
                                            value={data?.conselho ?? ''}
                                            disabled={!!data?.conselhoNaoAplicavel}
                                            onChange={e => setData({ ...data, ...{ "conselho": e.target.value } })}
                                        />
                                    </div>
                                ) : null}

                                {!tipoHcp && !naoFarmaceutico && !ocultarCamposBR && (data?.evento?.camposQuestionario?.crmuf ?? "nao") === "sim" ? (
                                    <FinField label={getText('estado_conselho_label')} required={!(data?.conselhoNaoAplicavel ?? false)} htmlFor="conselhouf">
                                        <ReactSelect
                                            id={"conselhouf"}
                                            isDisabled={!!data?.conselhoNaoAplicavel}
                                            value={{ value: data?.conselhouf ?? '', label: data?.conselhouf ?? '' }}
                                            onChange={e => setData({ ...data, ...{ "conselhouf": e.value } })}
                                            options={[
                                                { value: "AC", label: "AC" },
                                                { value: "AL", label: "AL" },
                                                { value: "AP", label: "AP" },
                                                { value: "AM", label: "AM" },
                                                { value: "BA", label: "BA" },
                                                { value: "CE", label: "CE" },
                                                { value: "DF", label: "DF" },
                                                { value: "ES", label: "ES" },
                                                { value: "GO", label: "GO" },
                                                { value: "MA", label: "MA" },
                                                { value: "MT", label: "MT" },
                                                { value: "MS", label: "MS" },
                                                { value: "MG", label: "MG" },
                                                { value: "PA", label: "PA" },
                                                { value: "PB", label: "PB" },
                                                { value: "PR", label: "PR" },
                                                { value: "PE", label: "PE" },
                                                { value: "PI", label: "PI" },
                                                { value: "RJ", label: "RJ" },
                                                { value: "RN", label: "RN" },
                                                { value: "RS", label: "RS" },
                                                { value: "RO", label: "RO" },
                                                { value: "RR", label: "RR" },
                                                { value: "SC", label: "SC" },
                                                { value: "SP", label: "SP" },
                                                { value: "SE", label: "SE" },
                                                { value: "TO", label: "TO" },
                                            ]}
                                        />
                                    </FinField>
                                ) : null}

                                {(data?.evento?.camposQuestionario?.datanascimento ?? "nao") === "sim" ? (
                                    <FinField label={getText('data_nascimento_label')} required>
                                        <InputMask
                                            mask="99/99/9999"
                                            className="fin-pp__input"
                                            id="datanascimento"
                                            value={data?.datanascimento ?? ''}
                                            onChange={e => setData({ ...data, ...{ "datanascimento": e.target.value } })}
                                            style={{ paddingLeft: 14 }}
                                        />
                                    </FinField>
                                ) : null}

                                {naoFarmaceutico && (data?.evento?.camposQuestionario?.cargoparticipante ?? "nao") === "sim" ? (
                                    <FinField label={getText('cargo_label')} required>
                                        <ReactSelect
                                            id="cargoparticipante"
                                            value={data?.cargoparticipante ? { value: data.cargoparticipante, label: data.nomeCargoparticipante } : null}
                                            onChange={e => setData({
                                                ...data,
                                                ...{ "cargoparticipante": e ? e.value : '', "nomeCargoparticipante": e ? e.label : '' },
                                                // trocar de "Outros" para outro cargo limpa a especificação
                                                ...(e && String(e.value) === CARGO_OUTROS ? {} : { "cargoespecificacao": '' })
                                            })}
                                            loadOptions={(input) => {
                                                return api({
                                                    method: 'get',
                                                    action: '/participanteCargo',
                                                    token: token,
                                                    params: { nome: input, categoria: CATEGORIA_NAO_FARMACEUTICO }
                                                })
                                                    .then(response => response.data.data.map(registro => ({ value: registro.id, label: registro.nome })))
                                                    .catch(function (error) {
                                                        //console.log(error);
                                                    });
                                            }}
                                        />
                                    </FinField>
                                ) : null}

                                {naoFarmaceutico && (data?.evento?.camposQuestionario?.cargoparticipante ?? "nao") === "sim"
                                    && String(data?.cargoparticipante ?? '') === CARGO_OUTROS ? (
                                    <FinField label={getText('cargo_especificacao_label')} required>
                                        <FinInput
                                            id="cargoespecificacao"
                                            value={data?.cargoespecificacao ?? ''}
                                            onChange={e => setData({ ...data, ...{ "cargoespecificacao": e.target.value } })}
                                            style={{ paddingLeft: 14 }}
                                        />
                                    </FinField>
                                ) : null}

                                {!naoFarmaceutico && (data?.evento?.camposQuestionario?.especialidade ?? "nao") === "sim" ? (
                                    <FinField label={getText('especialidade_label')} required>
                                        <FinInput
                                            id="especialidade"
                                            value={data?.especialidade ?? ''}
                                            onChange={e => setData({ ...data, ...{ "especialidade": e.target.value } })}
                                            style={{ paddingLeft: 14 }}
                                        />
                                    </FinField>
                                ) : null}

                                {(data?.evento?.camposQuestionario?.instituicao ?? "nao") === "sim" ? (
                                    <FinField label={getText('instituicao_label')} required>
                                        <FinInput
                                            id="instituicao"
                                            value={data?.instituicao ?? ''}
                                            onChange={e => setData({ ...data, ...{ "instituicao": e.target.value } })}
                                            style={{ paddingLeft: 14 }}
                                        />
                                    </FinField>
                                ) : null}

                                {(data?.evento?.camposQuestionario?.idconvidado ?? "nao") === "sim" ? (
                                    <FinField label={getText('id_convidado_label')} required>
                                        <FinInput
                                            id="idconvidado"
                                            value={data?.idconvidado ?? ''}
                                            onChange={e => setData({ ...data, ...{ "idconvidado": e.target.value } })}
                                            style={{ paddingLeft: 14 }}
                                        />
                                    </FinField>
                                ) : null}

                                {(data?.evento?.camposQuestionario?.socio ?? "nao") === "sim" ? (
                                    <FinField label={getText('socio_label')} required>
                                        <FinInput
                                            id="socio"
                                            value={data?.socio ?? ''}
                                            onChange={e => setData({ ...data, ...{ "socio": e.target.value } })}
                                            style={{ paddingLeft: 14 }}
                                        />
                                    </FinField>
                                ) : null}

                                {(data?.evento?.camposQuestionario?.passaporte ?? "nao") === "sim" ? (
                                    <FinField label={getText('passaporte_label')} required>
                                        <FinInput
                                            id="passaporte"
                                            value={data?.passaporte ?? ''}
                                            onChange={e => setData({ ...data, ...{ "passaporte": e.target.value } })}
                                            style={{ paddingLeft: 14 }}
                                        />
                                    </FinField>
                                ) : null}

                                {(data?.evento?.camposQuestionario?.passaportevencimento ?? "nao") === "sim" ? (
                                    <FinField label={getText('passaporte_vencimento_label')} required>
                                        <FinInput
                                            id="passaportevencimento"
                                            value={data?.passaportevencimento ?? ''}
                                            onChange={e => setData({ ...data, ...{ "passaportevencimento": e.target.value } })}
                                            style={{ paddingLeft: 14 }}
                                        />
                                    </FinField>
                                ) : null}

                                {(data?.evento?.camposQuestionario?.produto ?? "nao") === "sim" ? (
                                    <FinField label={getText('produto_label')} required>
                                        <FinInput
                                            id="produto"
                                            value={data?.produto ?? ''}
                                            onChange={e => setData({ ...data, ...{ "produto": e.target.value } })}
                                            style={{ paddingLeft: 14 }}
                                        />
                                    </FinField>
                                ) : null}

                                {(data?.evento?.camposQuestionario?.ordeminterna ?? "nao") === "sim" ? (
                                    <FinField label={getText('ordem_interna_label')} required>
                                        <FinInput
                                            id="ordeminterna"
                                            value={data?.ordeminterna ?? ''}
                                            onChange={e => setData({ ...data, ...{ "ordeminterna": e.target.value } })}
                                            style={{ paddingLeft: 14 }}
                                        />
                                    </FinField>
                                ) : null}

                                {(data?.evento?.camposQuestionario?.gerentecomercial ?? "nao") === "sim" ? (
                                    <FinField label={getText('gerente_comercial_label')} required>
                                        <FinInput
                                            id="gerentecomercial"
                                            value={data?.gerentecomercial ?? ''}
                                            onChange={e => setData({ ...data, ...{ "gerentecomercial": e.target.value } })}
                                            style={{ paddingLeft: 14 }}
                                        />
                                    </FinField>
                                ) : null}

                                {(data?.evento?.camposQuestionario?.gerentedistrital ?? "nao") === "sim" ? (
                                    <FinField label={getText('gerente_distrital_label')} required>
                                        <FinInput
                                            id="gerentedistrital"
                                            value={data?.gerentedistrital ?? ''}
                                            onChange={e => setData({ ...data, ...{ "gerentedistrital": e.target.value } })}
                                            style={{ paddingLeft: 14 }}
                                        />
                                    </FinField>
                                ) : null}

                                {(data?.evento?.camposQuestionario?.gerentedistritalemail ?? "nao") === "sim" ? (
                                    <FinField label={getText('gerente_distrital_email_label')} required>
                                        <FinInput
                                            id="gerentedistritalemail"
                                            value={data?.gerentedistritalemail ?? ''}
                                            onChange={e => setData({ ...data, ...{ "gerentedistritalemail": e.target.value } })}
                                            style={{ paddingLeft: 14 }}
                                        />
                                    </FinField>
                                ) : null}

                                {(data?.evento?.camposQuestionario?.representante ?? "nao") === "sim" ? (
                                    <FinField label={getText('representante_label')} required>
                                        <FinInput
                                            id="representante"
                                            value={data?.representante ?? ''}
                                            onChange={e => setData({ ...data, ...{ "representante": e.target.value } })}
                                            style={{ paddingLeft: 14 }}
                                        />
                                    </FinField>
                                ) : null}

                                {(data?.evento?.camposQuestionario?.representanteemail ?? "nao") === "sim" ? (
                                    <FinField label={getText('representante_email_label')} required>
                                        <FinInput
                                            id="representanteemail"
                                            value={data?.representanteemail ?? ''}
                                            onChange={e => setData({ ...data, ...{ "representanteemail": e.target.value } })}
                                            style={{ paddingLeft: 14 }}
                                        />
                                    </FinField>
                                ) : null}

                                {(data?.evento?.camposQuestionario?.representantetelefone ?? "nao") === "sim" ? (
                                    <FinField label={getText('representante_telefone_label')} required>
                                        <InputMask
                                            mask="(99) 99999-9999"
                                            className="fin-pp__input"
                                            id="representantetelefone"
                                            value={data?.representantetelefone ?? ''}
                                            onChange={e => setData({ ...data, ...{ "representantetelefone": e.target.value } })}
                                            style={{ paddingLeft: 14 }}
                                        />
                                    </FinField>
                                ) : null}

                                {(data?.evento?.camposQuestionario?.enderecocep ?? "nao") === "sim" ? (
                                    <FinField label={getText('cep_label')} required>
                                        <FinInput
                                            id="enderecocep"
                                            value={data?.enderecocep ?? ''}
                                            onChange={(e) => {
                                                const updated = { ...data, enderecocep: e.target.value };
                                                preencherCep(e.target.value, updated);
                                                setData(updated);
                                            }}
                                            style={{ paddingLeft: 14 }}
                                        />
                                    </FinField>
                                ) : null}

                                {(data?.evento?.camposQuestionario?.enderecologradouro ?? "nao") === "sim" ? (
                                    <FinField label={getText('rua_logradouro_label')} required>
                                        <FinInput
                                            id="enderecologradouro"
                                            value={data?.enderecologradouro ?? ''}
                                            onChange={e => setData({ ...data, ...{ "enderecologradouro": e.target.value } })}
                                            style={{ paddingLeft: 14 }}
                                        />
                                    </FinField>
                                ) : null}

                                {(data?.evento?.camposQuestionario?.endereconumero ?? "nao") === "sim" ? (
                                    <FinField label={getText('numero_label')} required>
                                        <FinInput
                                            id="endereconumero"
                                            value={data?.endereconumero ?? ''}
                                            onChange={e => setData({ ...data, ...{ "endereconumero": e.target.value } })}
                                            style={{ paddingLeft: 14 }}
                                        />
                                    </FinField>
                                ) : null}

                                {(data?.evento?.camposQuestionario?.enderecocomplemento ?? "nao") === "sim" ? (
                                    <FinField label={getText('complemento_label')}>
                                        <FinInput
                                            id="enderecocomplemento"
                                            value={data?.enderecocomplemento ?? ''}
                                            onChange={e => setData({ ...data, ...{ "enderecocomplemento": e.target.value } })}
                                            style={{ paddingLeft: 14 }}
                                        />
                                    </FinField>
                                ) : null}

                                {(data?.evento?.camposQuestionario?.enderecobairro ?? "nao") === "sim" ? (
                                    <FinField label={getText('bairro_label')} required>
                                        <FinInput
                                            id="enderecobairro"
                                            value={data?.enderecobairro ?? ''}
                                            onChange={e => setData({ ...data, ...{ "enderecobairro": e.target.value } })}
                                            style={{ paddingLeft: 14 }}
                                        />
                                    </FinField>
                                ) : null}

                                {!ocultarCamposBR && isCampoAtivo('enderecomunicipio', 'enderecomunicipionome') ? (
                                    <FinField label={getText('cidade_label')} required>
                                        <ReactSelect
                                            id={"enderecomunicipio"}
                                            value={{ value: data?.enderecomunicipio ?? '', label: data?.nomeEnderecomunicipio ?? '' }}
                                            onChange={e => setData({ ...data, ...{ "enderecomunicipio": e.value, "nomeEnderecomunicipio": e.label } })}
                                            loadOptions={(input) => {
                                                return api({
                                                    method: 'get',
                                                    action: '/municipio',
                                                    token: token,
                                                    params: {
                                                        nome: input,
                                                        uf: data?.enderecouf ?? ''
                                                    }
                                                })
                                                    .then(response => {
                                                        let options = response.data.data.map(registro => ({ value: registro.id, label: registro.nome + "-" + registro.uf }));
                                                        return options;
                                                    })
                                                    .catch(function (error) {
                                                        //console.log(error);
                                                    });
                                            }}
                                        />
                                    </FinField>
                                ) : null}

                                {!ocultarCamposBR && isCampoAtivo('enderecouf', 'enderecomunicipiouf') ? (
                                    <FinField label={getText('estado_label')} required>
                                        <ReactSelect
                                            id={"enderecouf"}
                                            value={{ value: data?.enderecouf ?? '', label: data?.enderecouf ?? '' }}
                                            onChange={e => setData({ ...data, ...{ "enderecouf": e.value, "nomeUf": e.label } })}
                                            options={[
                                                { value: "AC", label: "AC" },
                                                { value: "AL", label: "AL" },
                                                { value: "AP", label: "AP" },
                                                { value: "AM", label: "AM" },
                                                { value: "BA", label: "BA" },
                                                { value: "CE", label: "CE" },
                                                { value: "DF", label: "DF" },
                                                { value: "ES", label: "ES" },
                                                { value: "GO", label: "GO" },
                                                { value: "MA", label: "MA" },
                                                { value: "MT", label: "MT" },
                                                { value: "MS", label: "MS" },
                                                { value: "MG", label: "MG" },
                                                { value: "PA", label: "PA" },
                                                { value: "PB", label: "PB" },
                                                { value: "PR", label: "PR" },
                                                { value: "PE", label: "PE" },
                                                { value: "PI", label: "PI" },
                                                { value: "RJ", label: "RJ" },
                                                { value: "RN", label: "RN" },
                                                { value: "RS", label: "RS" },
                                                { value: "RO", label: "RO" },
                                                { value: "RR", label: "RR" },
                                                { value: "SC", label: "SC" },
                                                { value: "SP", label: "SP" },
                                                { value: "SE", label: "SE" },
                                                { value: "TO", label: "TO" },
                                            ]}
                                        />
                                    </FinField>
                                ) : null}

                                {(data?.evento?.camposQuestionario?.inscricao ?? "nao") === "sim" ? (
                                    <FinField label={getText('inscricao_label')} required>
                                        <ReactSelect
                                            id={"inscricao"}
                                            value={{ value: data?.inscricao ?? '', label: data?.nomeInscricao ?? '' }}
                                            onChange={e => setData({ ...data, ...{ "inscricao": e.value, "nomeInscricao": e.label } })}
                                            options={[
                                                { value: 'nao', label: getText('nao') },
                                                { value: 'sim', label: getText('sim') },
                                                { value: 'cld', label: getText('cancelado') },
                                            ]}
                                        />
                                    </FinField>
                                ) : null}

                                {(data?.evento?.camposQuestionario?.inscricaonumero ?? "nao") === "sim" ? (
                                    <FinField label={getText('inscricao_numero_label')} required>
                                        <FinInput
                                            id="inscricaonumero"
                                            value={data?.inscricaonumero ?? ''}
                                            onChange={e => setData({ ...data, ...{ "inscricaonumero": e.target.value } })}
                                            style={{ paddingLeft: 14 }}
                                        />
                                    </FinField>
                                ) : null}

                                {(!ocultarCamposBR && ((data?.aereo ?? "nao") === "sim") && ((data?.evento?.camposQuestionario?.aereomunicipioembarque ?? "nao") === "sim")) ? (
                                    <FinField label={getText('cidade_embarque_label')} required>
                                        <ReactSelect
                                            value={{ value: data?.aereomunicipioembarque ?? '', label: data?.nomeAereomunicipioembarque ?? '' }}
                                            onChange={e => setData({ ...data, ...{ "aereomunicipioembarque": e.value, "nomeAereomunicipioembarque": e.label } })}
                                            loadOptions={(input) => {
                                                return api({
                                                    method: 'get',
                                                    action: '/municipio',
                                                    token: token,
                                                    params: {
                                                        nome: input,
                                                    }
                                                })
                                                    .then(response => {
                                                        let options = response.data.data.map(registro => ({ value: registro.id, label: registro.nome + "-" + registro.uf }));
                                                        return options;
                                                    })
                                                    .catch(function (error) {
                                                        //console.log(error);
                                                    });
                                            }}
                                        />
                                    </FinField>
                                ) : null}

                                {(data?.evento?.camposQuestionario?.observacao ?? "nao") === "sim" ? (
                                    <FinField label={getText('observacao_label')} full required>
                                        <FinTextarea
                                            id="observacao"
                                            value={data?.observacao ?? ''}
                                            onChange={e => setData({ ...data, ...{ "observacao": e.target.value } })}
                                            placeholder={getText('observacao')}
                                            style={{ minHeight: '120px' }}
                                        />
                                    </FinField>
                                ) : null}

                                {/* Sem 1..10 fixo: a lista vem do evento, então a 11ª coluna em diante
                                    aparece aqui sozinha. Só entram as marcadas para questionar e não
                                    travadas no cadeado. */}
                                {(data?.colunas ?? []).map(coluna => (
                                    (coluna.questionar && coluna.ativo) ? (
                                        <FinField key={coluna.id} label={coluna.nome} required>
                                            <FinInput
                                                id={'coluna' + coluna.ordem}
                                                value={coluna.valor ?? ''}
                                                onChange={e => {
                                                    const valor = e.target.value;
                                                    setData({
                                                        ...data,
                                                        colunas: data.colunas.map(atual => (
                                                            atual.id === coluna.id ? { ...atual, valor } : atual
                                                        )),
                                                    });
                                                }}
                                                style={{ paddingLeft: 14 }}
                                            />
                                        </FinField>
                                    ) : null
                                ))}
                            </div>{/* fin-pp__filters */}

                            {(data?.evento?.camposQuestionario?.necessidadeespecial ?? "nao") === "sim" ? (
                                <div className="fin-pp__card" style={{ padding: '16px', marginTop: '16px' }}>
                                    <p style={{ marginBottom: '12px', color: 'var(--fin-mt)' }}>{getText('necessidade_especial_descricao')}</p>
                                    <div style={{ display: 'flex', gap: '24px', flexWrap: 'wrap' }}>
                                        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', minWidth: '260px' }}>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                <input
                                                    type="checkbox"
                                                    id="restricaoalimentarCheck"
                                                    checked={data?.restricaoalimentarCheck ?? false}
                                                    onChange={e => {
                                                        const isChecked = e.target.checked;
                                                        setData({
                                                            ...data,
                                                            restricaoalimentarCheck: isChecked,
                                                            restricaoalimentar: isChecked ? data?.restricaoalimentar : ''
                                                        });
                                                    }}
                                                />
                                                <label htmlFor="restricaoalimentarCheck">{getText('restricao_alimentar_label')}</label>
                                            </div>
                                            <input
                                                type="text"
                                                className="fin-pp__input"
                                                id="restricaoalimentar"
                                                placeholder={getText('especifique_restricao_alimentar')}
                                                value={data?.restricaoalimentar ?? ''}
                                                onChange={e => {
                                                    const value = e.target.value;
                                                    setData({
                                                        ...data,
                                                        restricaoalimentar: value,
                                                        restricaoalimentarCheck: value ? true : data?.restricaoalimentarCheck
                                                    });
                                                }}
                                                style={{ paddingLeft: 14 }}
                                            />
                                        </div>
                                        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', minWidth: '260px' }}>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                <input
                                                    type="checkbox"
                                                    id="pcdCheck"
                                                    checked={data?.pcdCheck ?? false}
                                                    onChange={e => {
                                                        const isChecked = e.target.checked;
                                                        setData({
                                                            ...data,
                                                            pcdCheck: isChecked,
                                                            pcd: isChecked ? data?.pcd : ''
                                                        });
                                                    }}
                                                />
                                                <label htmlFor="pcdCheck">{getText('pcd_label')}</label>
                                            </div>
                                            <input
                                                type="text"
                                                className="fin-pp__input"
                                                id="pcd"
                                                placeholder={getText('especifique_necessidade_especial')}
                                                value={data?.pcd ?? ''}
                                                onChange={e => {
                                                    const value = e.target.value;
                                                    setData({
                                                        ...data,
                                                        pcd: value,
                                                        pcdCheck: value ? true : data?.pcdCheck
                                                    });
                                                }}
                                                style={{ paddingLeft: 14 }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            ) : null}

                            {(data?.evento?.cliente?.modelo ?? "") === "access" && (
                                <div className="fin-pp__card" style={{ padding: '16px', marginTop: '16px' }}>
                                    <div>
                                        <label style={{ fontSize: "16px", fontWeight: "600", marginBottom: "12px", display: "block", color: 'var(--fin-tx)' }}>
                                            {getText('levaraAcompanhantes')}
                                        </label>
                                        <div style={{ display: "flex", gap: "24px", marginBottom: "16px" }}>
                                            <label style={{ display: "flex", alignItems: "center", gap: "8px", cursor: "pointer", fontSize: "16px" }}>
                                                <input
                                                    type="radio"
                                                    name="levaraAcompanhantes"
                                                    value="nao"
                                                    checked={(data?.levaraAcompanhantes ?? "nao") === "nao"}
                                                    onChange={() => setData({ ...data, levaraAcompanhantes: "nao", acompanhantes: "" })}
                                                />
                                                {getText('nao')}
                                            </label>
                                            <label style={{ display: "flex", alignItems: "center", gap: "8px", cursor: "pointer", fontSize: "16px" }}>
                                                <input
                                                    type="radio"
                                                    name="levaraAcompanhantes"
                                                    value="sim"
                                                    checked={(data?.levaraAcompanhantes ?? "nao") === "sim"}
                                                    onChange={() => setData({ ...data, levaraAcompanhantes: "sim" })}
                                                />
                                                {getText('sim')}
                                            </label>
                                        </div>
                                        {(data?.levaraAcompanhantes ?? "nao") === "sim" && (
                                            <div>
                                                <label htmlFor="acompanhantes" style={{ fontSize: "15px", marginBottom: "8px", display: "block", color: 'var(--fin-mt)' }}>
                                                    {getText('acompanhantesInstrucao')}
                                                </label>
                                                <textarea
                                                    id="acompanhantes"
                                                    className="fin-pp__input"
                                                    rows="6"
                                                    placeholder={getText('acompanhantesExemplo')}
                                                    value={data?.acompanhantes ?? ""}
                                                    onChange={e => setData({ ...data, acompanhantes: e.target.value })}
                                                    style={{ fontSize: "15px", borderRadius: "8px", padding: "12px", height: 'auto', width: '100%' }}
                                                />
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )}
                        </form>
                    </div>{/* fin-pp__card */}
                </>}{/* conditional */}
            </div>{/* main-content */}
        </ErpTemplate>
    );
}
